import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  uploaderContainer: ({ spacing }) => css`
    margin-top: ${spacing.sm};
  `,
  attachments: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,
})

export default useStyles
